import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC } from 'react'

import { MediaGalleryBanner } from '@Blocks/MediaGalleryBlock/MediaGalleryBannerBlock/Components/MediaGalleryBanner/MediaGalleryBanner'
import { MediaGalleryBannerCard } from '@Blocks/MediaGalleryBlock/MediaGalleryBannerBlock/Components/MediaGalleryBannerCard/MediaGalleryBannerCard'
import { MediaGalleryBlockType } from '@Blocks/MediaGalleryBlock/MediaGalleryBlockType'
import { MediaGalleryCardProps } from '@Components/MediaGalleryCard'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { HorizontalCarousel } from '@Shared/Components/Carousels/HorizontalCarousel/HorizontalCarousel'

import styles from './MediaGalleryBannerBlock.module.scss'

interface MediaGalleryBannerBlockProps extends MediaGalleryBlockType{
  bannerCard?: MediaGalleryCardProps
  fullWidth?: boolean
  zigzag?: boolean
}

export const MediaGalleryBannerBlock: FC<MediaGalleryBannerBlockProps> = ({ bannerCard, cards, fullWidth = false, zigzag = false }) => {
  const openModal = useCMSModalOpen()

  return (
    <div className={clsx(styles.mediaGalleryBannerBlock, fullWidth && styles.fullWidth)}>
      {!!bannerCard?.image && (
        <MediaGalleryBanner
          card={bannerCard}
          openModal={(type, id) => {
            if (type && id) {
              openModal(type, id)
            }
          }}
        />
      )}
      <HorizontalCarousel
        buttonFloat
        carouselClassName={clsx(styles.horizontalCarousel, zigzag && styles.zigzag)}
        gap={5}
        progressClassName={styles.progressCarousel}
        showButtons
        showProgressbar
        snap
      >
        {map(cards, (card: MediaGalleryCardProps) => (
          <MediaGalleryBannerCard
            key={card.id}
            card={card}
            openModal={(type, id) => {
              if (type && id) {
                openModal(type, id)
              }
            }}
          />
        ))}
      </HorizontalCarousel>
    </div>
  )
}
